import type { IUpdateOfficeSetupRequest } from '~/domain/UpdateOfficeSetup';
import { SoftwareUtils } from '~/utils/SoftwareUtils';
import type { ISignUpFormValues } from '../types';

interface IBuildArgs {
  values: Pick<
    ISignUpFormValues,
    'timePerPatient' | 'assistedHygiene' | 'parkingInfo' | 'softwares' | 'insurances'
  >;
  isProfileComplete: boolean;
}

export const buildUpdateOfficeSetupInput = ({
  values,
  isProfileComplete,
}: IBuildArgs): IUpdateOfficeSetupRequest => {
  const { timePerPatient, assistedHygiene, parkingInfo, softwares, insurances } = values;
  const isFree = parkingInfo.isFree === 'yes';

  return {
    timePerPatientRDH: timePerPatient.rdh,
    timePerPatientDA: timePerPatient.da,
    timePerPatientDN: timePerPatient.ddn,
    isAssistedHygiene: assistedHygiene === 'yes',
    parkingInformation: {
      isParkingFree: isFree,
      cost: isFree ? undefined : Number(parkingInfo.cost),
      costType: isFree ? undefined : (parkingInfo.unit as 'hr' | 'day'),
      parkingType: parkingInfo.type,
    },
    // Pills carry the translated label (e.g. "DOX") — revert to the canonical
    // BE name ("Dental Office Xpress (DOX)") before persisting.
    softwares: SoftwareUtils.getSoftwareOriginalValues(softwares),
    insurances,
    isInfoAsked: true,
    isProfileComplete,
  };
};
